export var GET_GLOBAL_NOTIFICATION_INIT = 'GET_GLOBAL_NOTIFICATION_INIT';
export var GET_GLOBAL_NOTIFICATION_SUCCESS = 'GET_GLOBAL_NOTIFICATION_SUCCESS';
export var GET_GLOBAL_NOTIFICATION_ERROR = 'GET_GLOBAL_NOTIFICATION_ERROR';
export var GET_GLOBAL_NOTIFICATION_DONE = 'GET_GLOBAL_NOTIFICATION_DONE';
